import {format} from "date-fns";

export default function getPeriodAnchor() {
  return format(new Date(), 'YYYY-MM-DD HH:mm:ss')
}
